<template>
    <div class="container my-5 p-4 main-container">

        <div class="text-center mb-5">
            <p class="text-uppercase tracking-wider mb-1">Quinta Edición</p>
            <h1 class="titulo-display display-3 text-uppercase">Carrera de Obstáculos</h1>
            <h2 class="h4 text-xhidenxi-sub fw-bold">XHIDENXHI</h2>
        </div>

        <form @submit.prevent="submitRegistration" novalidate :class="{ 'was-validated': validated }">

            <!-- Selección Botones -->
            <div class="mb-5 text-center">
                <label class="form-label d-block fw-bold text-uppercase mb-3">Selecciona tu Reto:</label>

                <div class="reto-container-wrapper">
                    <div class="btn-group w-100 custom-btn-group" role="group">
                        <input type="radio" class="btn-check" name="reto" id="retoIndividual" value="individual"
                            v-model="formData.tipoReto">
                        <label class="btn custom-btn" for="retoIndividual">
                            Reto Individual
                        </label>

                        <input type="radio" class="btn-check" name="reto" id="retoPareja" value="pareja"
                            v-model="formData.tipoReto">
                        <label class="btn custom-btn" for="retoPareja">
                            Reto por Pareja
                        </label>
                    </div>
                </div>
            </div>

            <div v-if="formData.tipoReto !== ''">
                <!-- Datos Competidor Principal -->
                <section class="mb-4">
                    <h4 class="section-title">Datos del Participante</h4>

                    <div class="row g-3">
                        <div class="col-md-9">
                            <label class="form-label form-control-text fw-bold">Nombre completo:</label>
                            <input v-model="formData.nombre" type="text" class="form-control"
                                placeholder="Escribe tu nombre completo" required>
                            <div class="invalid-feedback">Por favor, ingresa el nombre.</div>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label form-control-text fw-bold">Edad:</label>
                            <input v-model="formData.edad" type="text" class="form-control" placeholder="Ej: 25"
                                @input="formData.edad = formData.edad.replace(/\D/g, '').slice(0, 2)" required>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label form-control-text fw-bold">Teléfono:</label>
                            <input v-model="formData.telefono" type="tel" class="form-control"
                                placeholder="Escribe tu teléfono"
                                @input="formData.telefono = formData.telefono.replace(/\D/g, '').slice(0, 10)" required>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label form-control-text fw-bold">Correo electrónico:</label>
                            <input v-model="formData.email" type="email" class="form-control"
                                placeholder="Escribe tu correo electrónico" required>
                        </div>
                        <div class="col-md-12">
                            <label class="form-label form-control-text fw-bold">Localidad, Municipio y Estado:</label>
                            <input v-model="formData.ubicacion" type="text" class="form-control"
                                placeholder="Escribe tu ubicación" required>
                        </div>
                        <div class="col-md-12">
                            <label class="form-label form-control-text fw-bold">Contacto de emergencia y nombre:</label>
                            <input v-model="formData.emergencia" type="text" class="form-control"
                                placeholder="Nombre - 5512345678" required>
                        </div>

                        <!-- Seccion género -->
                        <div class="col-12">
                            <label class="form-label form-control-text fw-bold">Género:</label>

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="genero" id="radioM" value="Mujer"
                                    v-model="formData.genero" required>
                                <label class="form-check-label" for="radioM">Mujer</label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="genero" id="radioH" value="Hombre"
                                    v-model="formData.genero" required>
                                <label class="form-check-label" for="radioH">Hombre</label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="genero" id="radioO" value="Otro"
                                    v-model="formData.genero" required>
                                <label class="form-check-label" for="radioO">Otro</label>
                            </div>

                            <div v-if="formData.genero == 'Otro'" class="mt-2">
                                <input type="text" class="form-control" placeholder="Escríbelo aqui (Opcional)"
                                    v-model="otroGenero">
                            </div>

                            <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.genero }">
                                Por favor selecciona un género.
                            </div>
                        </div>

                        <div class="col-12">
                            <label class="form-label form-control-text fw-bold">Talla de camiseta:</label>

                            <select class="form-select" v-model="formData.tallaCamisa" required>
                                <option selected disabled value="">Selecciona una talla</option>
                                <option value="XS">XS (Extra Chica)</option>
                                <option value="S">S (Chica)</option>
                                <option value="M">M (Mediana)</option>
                                <option value="L">L (Grande)</option>
                                <option value="XL">XL (Extra Grande)</option>
                            </select>

                            <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.tallaCamisa }">
                                Por favor selecciona una talla.
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Datos Segundo Competidor (Condicional) -->
                <Transition name="fade">
                  <section v-if="formData.tipoReto === 'pareja'" class="mb-4 pt-3 border-top border-secondary">
                    <h4 class="section-title">Datos del Competidor 2 (Pareja)</h4>
                    <div class="row g-3">
                      <div class="col-md-9">
                        <label class="form-label form-control-text fw-bold">Nombre completo:</label>
                        <input v-model="formData.pareja.nombre" type="text" class="form-control"
                          placeholder="Escribe tu nombre completo" required>
                        <div class="invalid-feedback">Por favor, ingresa el nombre de tu pareja.</div>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label form-control-text fw-bold">Edad:</label>
                        <input v-model="formData.pareja.edad" type="text" class="form-control" placeholder="Ej: 25"
                          @input="formData.pareja.edad = formData.pareja.edad.replace(/\D/g, '').slice(0, 2)" required>
                        <div class="invalid-feedback">Ingresa la edad.</div>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label form-control-text fw-bold">Teléfono:</label>
                        <input v-model="formData.pareja.telefono" type="tel" class="form-control"
                          placeholder="Escribe tu teléfono"
                          @input="formData.pareja.telefono = formData.pareja.telefono.replace(/\D/g, '').slice(0, 10)" required>
                        <div class="invalid-feedback">Ingresa un teléfono válido.</div>
                      </div>

                      <div class="col-md-6">
                        <label class="form-label form-control-text fw-bold">Correo electrónico:</label>
                        <input v-model="formData.pareja.email" type="email" class="form-control"
                          placeholder="Escribe tu correo electrónico" required>
                        <div class="invalid-feedback">Ingresa un correo válido.</div>
                      </div>

                      <div class="col-md-12">
                        <label class="form-label form-control-text fw-bold">Localidad, Municipio y Estado:</label>
                        <input v-model="formData.pareja.ubicacion" type="text" class="form-control"
                          placeholder="Escribe tu ubicación" required>
                        <div class="invalid-feedback">Por favor, ingresa la ubicación.</div>
                      </div>

                      <!-- Seccion género pareja -->
                      <div class="col-12">
                        <label class="form-label form-control-text fw-bold">Género:</label>

                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="generoPareja" id="radioParejaM" value="Mujer"
                            v-model="formData.pareja.genero" required>
                          <label class="form-check-label" for="radioParejaM">Mujer</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="generoPareja" id="radioParejaH" value="Hombre"
                            v-model="formData.pareja.genero" required>
                          <label class="form-check-label" for="radioParejaH">Hombre</label>
                        </div>

                        <div class="form-check">
                          <input class="form-check-input" type="radio" name="generoPareja" id="radioParejaO" value="Otro"
                            v-model="formData.pareja.genero" required>
                          <label class="form-check-label" for="radioParejaO">Otro</label>
                        </div>

                        <div v-if="formData.pareja.genero == 'Otro'" class="mt-2">
                          <input type="text" class="form-control" placeholder="Escríbelo aqui (Opcional)"
                            v-model="otroGeneroPareja">
                        </div>

                        <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.pareja.genero }">
                          Por favor selecciona un género.
                        </div>
                      </div>

                      <div class="col-12">
                        <label class="form-label form-control-text fw-bold">Talla de camiseta:</label>

                        <select class="form-select" v-model="formData.pareja.tallaCamisa" required>
                          <option selected disabled value="">Selecciona una talla</option>
                          <option value="XS">XS (Extra Chica)</option>
                          <option value="S">S (Chica)</option>
                          <option value="M">M (Mediana)</option>
                          <option value="L">L (Grande)</option>
                          <option value="XL">XL (Extra Grande)</option>
                        </select>

                        <div class="invalid-feedback" :class="{ 'd-block': validated && !formData.pareja.tallaCamisa }">
                          Por favor selecciona una talla.
                        </div>
                      </div>
                    </div>
                  </section>
                </Transition>

                <!-- Información de Pago -->
                <section class="mb-4 pt-3 border-top border-secondary">
                    <h4 class="section-title">Información de Pago y Grupo</h4>

                    <div class="row g-3">
                        <div class="col-md-12">
                            <label class="form-label form-control-text fw-bold">
                                {{
                                    formData.tipoReto === 'individual'
                                        ? '¿Perteneces a algún grupo de corredores? (Nombre y Origen) opcional'
                                        : '¿Pertenecen a algún grupo de corredores? (Nombre y Origen) opcional'
                                }}
                            </label>
                            <input v-model="formData.grupo" type="text" class="form-control" placeholder="Ej: Grupo X">
                        </div>
                        <div class="col-md-6">
                            <label class="form-label form-control-text fw-bold">Monto pagado</label>
                            <div class="input-group">
                                <span class="input-group-text">$</span>
                                <input v-model="formData.pagoMonto" type="number" class="form-control" required>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label form-control-text fw-bold">Fecha de pago</label>
                            <input v-model="formData.pagoFecha" type="date" class="form-control" required>
                        </div>
                        <div class="col-12">
                            <label class="form-label form-control-text fw-bold">Comprobante de pago</label>
                            <input type="file" @change="handleFile" ref="archivoInput" class="form-control" accept="image/*,.pdf"
                                required>
                        </div>
                    </div>
                </section>

                <!-- Boton de acción -->
                <div class="d-grid gap-2 mt-5">
                    <button type="submit" class="btn-canicross w-100 py-3 fw-bold shadow">
                        {{ formData.tipoReto === 'individual' ? 'INSCRIBIRME' : 'INSCRIBIRME CON MI PAREJA' }}
                    </button>
                </div>
            </div>

        </form>

        <AppLoader :show="isLoading" />
    </div>
</template>

<script setup>
import { reactive, ref, watch, onMounted } from 'vue'
import { useToast } from 'vue-toast-notification'
import { db, storage } from '@/firebase/firebase'
import { query, where, getDocs, collection, addDoc, serverTimestamp, updateDoc, doc, runTransaction, limit } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import imageCompression from 'browser-image-compression'
import router from '@/router'
import AppLoader from '@/components/AppLoader.vue'

const collectionName = 'corredores_obstaculos_julio_2026'
const counterObstacleRegisters = 'contador_corredores_obstaculos_julio_2026'
const storageFolder = 'comprobantes_obstaculos_julio_2026'

const $toast = useToast()

const archivoComprobante = ref(null)
const archivoInput = ref(null)

const otroGenero = ref('')
const otroGeneroPareja = ref('')
const validated = ref(false)
const isLoading = ref(false)

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

const formData = reactive({
  tipoReto: '',
  nombre: '',
  edad: '',
  telefono: '',
  ubicacion: '',
  email: '',
  emergencia: '',
  tallaCamisa: '',
  genero: '',
  pareja: {
    nombre: '',
    edad: '',
    telefono: '',
    ubicacion: '',
    email: '',
    tallaCamisa: '',
    genero: ''
  },
  grupo: '',
  pagoMonto: '',
  pagoFecha: '',
  comprobante: null
})

const handleFile = (e) => {
  const target = e.target

  if (!target.files || target.files.length === 0) {
    archivoComprobante.value = null
    return
  }

  const file = target.files[0]
  const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024

  if (file.size > MAX_FILE_SIZE_BYTES) {
    $toast.error('El archivo seleccionado es demasiado grande. Por favor, elige un archivo de menos de 5 MB.', {
      position: 'top-right',
      duration: 6000
    })
    archivoComprobante.value = null
    if (target) target.value = ''
    return
  }

  archivoComprobante.value = file
}

const handleFileUpload = async (numCorredor, idDoc, archivoComprobante) => {
  if (!archivoComprobante.value) return true

  try {
    const file = await comprimirImagen(archivoComprobante.value)
    const ext = file.name.split('.').pop()
    const safeName = `comprobante_${idDoc}_${numCorredor}.${ext}`

    const formatterNumCorredor = String(numCorredor).padStart(4, '0')
    const path = `${storageFolder}/CorredorNum_${formatterNumCorredor}/${safeName}`
    const refPath = storageRef(storage, path)

    await uploadBytes(refPath, file)
    const url = await getDownloadURL(refPath)

    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: url,
      comprobanteError: false
    })
    return true
  } catch (uploadError) {
    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: null,
      comprobanteError: true,
      errorSubidaComprobante: uploadError.message
    })

    $toast.warning(
      'Tu registro está listo, pero hubo un detalle al subir la foto de tu comprobante. El staff lo revisará.',
      { position: 'top-right', duration: 8000 }
    )

    return false
  }
}

const submitRegistration = async (event) => {
  validated.value = true
  const formDataEvent = event.target

  if (!formDataEvent.checkValidity()) {
    return
  }

  const datosAEnviar = {
    ...formData,
    email: formData.email.trim().toLowerCase()
  }

  delete datosAEnviar.comprobante

  if (datosAEnviar.genero === 'Otro' && otroGenero.value.trim() !== '') {
    datosAEnviar.genero = otroGenero.value.trim()
  }

  if (datosAEnviar.tipoReto === 'pareja') {
    datosAEnviar.pareja = {
      ...formData.pareja,
      email: formData.pareja.email.trim().toLowerCase()
    }

    if (datosAEnviar.pareja.genero === 'Otro' && otroGeneroPareja.value.trim() !== '') {
      datosAEnviar.pareja.genero = otroGeneroPareja.value.trim()
    }
  } else {
    delete datosAEnviar.pareja
  }

  try {
    isLoading.value = true

    const emailQuery = query(
      collection(db, collectionName),
      where('email', '==', datosAEnviar.email),
      limit(1)
    )

    const emailSnap = await getDocs(emailQuery)

    if (!emailSnap.empty) {
      $toast.error('Este correo electrónico ya se encuentra registrado para la carrera.', {
        position: 'top-right',
        duration: 6000
      })
      isLoading.value = false
      return
    }

    const numeroCorredor = await runTransaction(db, async (transaction) => {
      const contadorRef = doc(db, counterObstacleRegisters, 'contador')
      const contadorSnap = await transaction.get(contadorRef)
      let currentCount = 0

      if (!contadorSnap.exists()) {
        transaction.set(contadorRef, { contadorCompetidores: 1 })
      } else {
        currentCount = contadorSnap.data().contadorCompetidores
      }

      const newCount = currentCount + 1
      transaction.update(contadorRef, { contadorCompetidores: newCount })
      return newCount
    })

    const docRef = await addDoc(collection(db, collectionName), {
      numeroCorredor: numeroCorredor,
      ...datosAEnviar,
      fechaRegistro: serverTimestamp(),
      comprobanteUrl: null,
      pagoConfirmado: false,
      pagoConfirmadoPor: null,
      fechaConfirmacionPago: null
    })

    if (archivoComprobante.value) {
      await handleFileUpload(numeroCorredor, docRef.id, archivoComprobante)
    }

    Object.assign(formData, {
      tipoReto: '',
      nombre: '',
      edad: '',
      telefono: '',
      ubicacion: '',
      email: '',
      emergencia: '',
      tallaCamisa: '',
      genero: '',
      pareja: {
        nombre: '',
        edad: '',
        telefono: '',
        ubicacion: '',
        email: '',
        tallaCamisa: '',
        genero: ''
      },
      grupo: '',
      pagoMonto: '',
      pagoFecha: '',
      comprobante: null
    })

    archivoComprobante.value = null
    if (archivoInput.value) archivoInput.value.value = null

    otroGenero.value = ''
    otroGeneroPareja.value = ''

    router.replace({
      name: 'Confirmacion registro julio 2026',
      params: { numeroCorredor: String(numeroCorredor) }
    })

    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (error) {
    await reportarError(
      'Registro Carrera Julio 2026',
      'submitRegistration',
      error,
      {
        email: formData.email,
        nombre: formData.nombre,
        tipoReto: formData.tipoReto
      }
    )

    $toast.error('Error al guardar el registro. Intenta de nuevo.', {
      position: 'top-right',
      duration: 5000
    })
  } finally {
    isLoading.value = false
    validated.value = false
  }
}

async function comprimirImagen (file) {
  if (!file || !file.type.includes('image')) return file

  const opciones = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1400,
    useWebWorker: true
  }

  return await imageCompression(file, opciones)
}

const reportarError = async (modulo, funcion, errorOriginal, contexto = {}) => {
  try {
    await addDoc(collection(db, 'logs_errores'), {
      fecha: serverTimestamp(),
      modulo: modulo,
      funcion: funcion,
      error: {
        name: errorOriginal.name || 'Error genérico',
        code: errorOriginal.code || 'N/A',
        message: errorOriginal.message || String(errorOriginal),
        stack: errorOriginal.stack || null
      },
      datosContexto: contexto,
      userAgent: navigator.userAgent
    })
  } catch (logError) {
    console.error('Fallo crítico: No se pudo guardar el log de error')
  }
}

watch(() => formData.genero, () => { validated.value = false })
watch(() => formData.tallaCamisa, () => { validated.value = false })
watch(() => formData.pareja?.genero, () => { validated.value = false })
watch(() => formData.pareja?.tallaCamisa, () => { validated.value = false })
</script>

<style scoped>
/* Las clases de animación para la transición del bloque de parejas */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@import url('https://fonts.googleapis.com/css2?family=Staatliches&family=Roboto:wght@400;700&display=swap');

.main-container {
  border: none;
  background-color: white;
  border-top: 5px solid black;
  font-family: 'Roboto', sans-serif;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  color: #000;
}

.titulo-display {
  font-family: 'Staatliches', cursive;
  letter-spacing: 2px;
  color: #ffffff;
  color: #000;
}

.date-badge {
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50px;
  padding: 5px 20px;
  font-weight: bold;
  letter-spacing: 1px;
}

/* Estilos de los inputs */
.form-control-text {
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: rgba(26, 62, 51, 0.8);
  margin: 0 0 5px 0;
}

.form-control:focus {
  color: black;
  border-color: #2e7d32;
  box-shadow: 0 0 0 0.25rem rgba(46, 125, 50, 0.25);
}

/* Estilo del Button Group personalizado */
.custom-btn-group .btn {
  border-width: 2px;
  transition: all 0.3s ease;
}

.btn-check:checked + .btn-outline-success {
  background-color: rgba(26, 62, 51, 0.8);
  border-color: rgba(26, 62, 51, 0.8);
  color: white;
  transform: scale(1.02);
  z-index: 2;
}

/* Contenedor exterior (El marco verde) */
.reto-container-wrapper {
  border: 2px solid rgba(26, 62, 51, 0.8);
  border-radius: 50px;
  padding: 5px;
  background-color: white;
}

/* Estilo base de los botones internos */
.custom-btn-group .custom-btn {
  border-radius: 40px !important;
  border: none;
  color: rgba(26, 62, 51, 0.8);
  font-weight: bold;
  text-transform: uppercase;
  padding: 12px 0;
  transition: all 0.3s ease;
  background-color: transparent;
}

/* Estilo cuando el botón NO está seleccionado (Hover) */
.custom-btn:hover {
  color: #4caf50;
  background-color: rgba(46, 125, 50, 0.1);
}

/* Estilo del botón SELECCIONADO */
.btn-check:checked + .custom-btn {
  background-color: rgba(26, 62, 51, 0.8) !important; /* Fondo verde sólido */
  color: white !important;               /* Texto blanco */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

/* Ajuste para que el grupo de botones no tenga estilos de borde por defecto de Bootstrap */
.btn-group {
  gap: 5px; /* Pequeño espacio entre los dos botones internos */
}

/* Animación de entrada para el segundo competidor */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.tracking-wider {
    color: #666;
  letter-spacing: 3px;
}

.section-title {
  color: #666;
  border-left: 5px solid rgba(26, 62, 51, 0.8);
  padding-left: 10px;
  margin-bottom: 1.5rem;
  font-weight: medium;
  font-family: 'Staatliches', cursive;
}

.text-xhidenxi-sub {
  font-size: 0.9rem;
  letter-spacing: 2px;
  color: rgba(26, 62, 51, 0.8);
  margin: 0 0 5px 0;
}

.btn-canicross {
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 14px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    transition: all 0.3s ease;
}

.btn-canicross:hover:not(:disabled) {
    background-color: #222;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.btn-canicross:disabled {
    background-color: #aaa;
    cursor: not-allowed;
}

.was-validated :invalid~.invalid-feedback {
  display: block;
}

.invalid-feedback {
  display: none;
}
</style>
